import {
  MILLISECONDS_PER_SECOND,
  MILLISECONDS_PER_MINUTE,
  MILLISECONDS_PER_HOUR,
  SECONDS_PER_MINUTE,
  MINUTES_PER_HOUR,
} from './constants'

function pad (str: number | string) : string {
  if ( typeof str === 'number' ) str = str.toString()
  return str.padStart(2, "0")
}

function msToTimestamp (ms: number) : string {
  const totalSeconds = Math.floor(ms / MILLISECONDS_PER_SECOND)
  const displaySeconds = totalSeconds % SECONDS_PER_MINUTE
  const totalMinutes = Math.floor(ms / MILLISECONDS_PER_MINUTE)
  const displayMinutes = totalMinutes % MINUTES_PER_HOUR
  const totalHours = Math.floor(ms / MILLISECONDS_PER_HOUR)
  return totalHours
    ? `${totalHours}:${pad(displayMinutes)}:${pad(displaySeconds)}`
    : `${pad(displayMinutes)}:${pad(displaySeconds)}`
}

export default msToTimestamp
